<!--
@component
Banner

Renders a thin strip banner image for the landing page.
-->

<script lang="ts">
  import getPath from '$utils/getPath';
  import settings from '$lib/config/settings.json';
  import { page } from '$app/state';

  interface Props {
    /** Optional alt text for the banner image. */
    alt?: string;
  }

  const { alt = '' }: Props = $props();

  // Tournament-specific banner filename (e.g. `banner-wc.jpg` /
  // `banner-euro.jpg`) comes from content (`content.tournamment[active]`).
  // The active tournament key is a one-time build setting in
  // `src/lib/config/settings.json`. Mirrors the lookup used by `common/Logo`.
  const tournament = settings.tournament.type as 'wc' | 'euro';
  const bannerFile = $derived(
    page.data?.content?.tournamment?.[tournament]?.banner ?? 'banner.jpg'
  );
  const src = $derived(getPath(`images/branding/${bannerFile}`));
</script>

<div class="banner">
  <img
    class="banner-img"
    {alt}
    role="presentation"
    width="2000"
    height="500"
    {src}
    aria-hidden="true"
  />
</div>

<svelte:head>
  <link rel="preload" as="image" href={src} fetchpriority="high" />
</svelte:head>

<style lang="scss">
  @use '../../../styles/mixins' as mixins;

  .banner {
    margin-block-start: -(75px+65px);
    @include mixins.article-fluid;
  }

  .banner-img {
    display: block;
    width: 100%;
    height: auto;
    min-height: 300px;
    max-height: 500px;
    object-fit: cover;
    margin-block: 0;
  }
</style>
